import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
// import './index.css';
import HelpIcon from "@mui/icons-material/Help";
import GppGoodIcon from "@mui/icons-material/GppGood";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LogoutIcon from "@mui/icons-material/Logout";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link, useNavigate } from "react-router-dom";
import PaymentIcon from "@mui/icons-material/Payment";
import FavoriteIcon from "@mui/icons-material/Favorite";
import useUser from "../../context/user/useUser";
import { logout } from "auth/authenticate";

const PatientSettings = () => {
  const { settings } = useUser();
  const { setUserRole } = useUser();
  const navigate = useNavigate();
  return (
    <div className="settingsMain">
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            width: "auto",
            height: "auto",
          },
        }}
      >
        <Paper elevation={1} className="paperContainer">
          <h3>Settings</h3>
          <div>
            <div>
              <Link to="payments" className="settingList">
                <ListItem button>
                  <ListItemIcon>
                    <PaymentIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Payments"
                    primaryTypographyProps={{
                      fontSize: "14px",
                      marginLeft: "-20px",
                      textDecoration: "none",
                    }}
                  />
                  <ListItemIcon>
                    <ChevronRightIcon />
                  </ListItemIcon>
                </ListItem>
              </Link>
            </div>
            <Link to="/favourites" className="settingList">
              <ListItem button>
                <ListItemIcon>
                  <FavoriteIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Favorites"
                  primaryTypographyProps={{
                    fontSize: "14px",
                    marginLeft: "-20px",
                  }}
                />
                <ListItemIcon>
                  <ChevronRightIcon />
                </ListItemIcon>
              </ListItem>
            </Link>

            <Link to="privacy" className="settingList">
              <ListItem button>
                <ListItemIcon>
                  <HelpIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Privacy Control"
                  primaryTypographyProps={{
                    fontSize: "14px",
                    marginLeft: "-20px",
                  }}
                />
                <ListItemIcon>
                  <ChevronRightIcon />
                </ListItemIcon>
              </ListItem>
            </Link>
            <Link to="security" className="settingList">
              <ListItem button>
                <ListItemIcon>
                  <GppGoodIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Security Control"
                  primaryTypographyProps={{
                    fontSize: "14px",
                    marginLeft: "-20px",
                  }}
                />
                <ListItemIcon>
                  <ChevronRightIcon />
                </ListItemIcon>
              </ListItem>
            </Link>
            <ListItem button>
              <ListItemIcon>
                <HelpIcon />
              </ListItemIcon>
              <ListItemText
                primary="Help Center"
                primaryTypographyProps={{
                  fontSize: "14px",
                  marginLeft: "-20px",
                }}
              />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItem>
            <ListItem button>
              <ListItemIcon>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText
                primary="Notifcation Settings"
                primaryTypographyProps={{
                  fontSize: "14px",
                  marginLeft: "-20px",
                }}
              />
              <ListItemIcon>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItem>
            <ListItem
              button
              onClick={() => {
                logout();
                setUserRole("GUEST");
                navigate("/login");
              }}
            >
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                primaryTypographyProps={{
                  fontSize: "14px",
                  marginLeft: "-20px",
                }}
              />
            </ListItem>
          </div>
        </Paper>
      </Box>
    </div>
  );
};
export default PatientSettings;
